export default __webpack_public_path__ + "static/media/conversation.bffc684f.svg";